import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import { QRCode } from "react-qr-svg";
import ReactToPrint from "react-to-print";

class PrintComponent extends Component {
  constructor(props) {
    super();
    this.state = {};
  }
  render() {
    return (
      <div>
        <ComponentToPrint
          ref={(el) => (this.componentRef = el)}
          onboarding={this.props.onboarding}
          qrData={this.props.qrData}
          typeOfQr={this.props.typeOfQr}
        />
        <div className="d-flex justify-content-center align-items-center py-4">
          <Button
            variant="outline-secondary"
            className="btn-md mr-4 px-5"
            onClick={() => {
              this.props.setOpenPrintPreview(false);
            }}
          >
            Cancel
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button variant="danger" type="button" className="btn-md px-5">
                Print
              </Button>
            )}
            content={() => this.componentRef}
          />
        </div>
      </div>
    );
  }
}
class ComponentToPrint extends Component {
  constructor(props) {
    super();
    this.state = {};
  }
  render() {
    return (
      <div className="row">
        {this.props &&
          this.props.qrData &&
          this.props.qrData.map((data, index) => {
            return (
              <div className="col-4" key={index}>
                <div
                  id="printme divtoprint"
                  style={{
                    boxShadow: "0px 3px 6px #00000029",
                  }}
                  className="d-flex justify-content-center "
                >
                  <div className="QRMain-onboarding" align="center">
                    <div className="QRInner-onboarding p-4">
                      <div>
                        <Image
                          fluid
                          src={
                            this.props.onboarding &&
                            this.props.onboarding.logo_url
                          }
                          alt="Logo"
                          style={{ width: "25%" }}
                        />
                      </div>
                      <div className="print-12-500-r text-uppercase f12-500">
                        <span className="">
                          {this.props.onboarding &&
                            this.props.onboarding.restaurant_name}
                        </span>
                      </div>
                      <div className="qrPript">
                        <QRCode
                          bgColor="#FFFFFF"
                          fgColor="#000000"
                          level="H"
                          style={{ width: "170px", heght: 77 }}
                          value={data._id}
                        />
                      </div>
                      {console.log(
                        this.props && this.props.typeOfQr && this.props.typeOfQr
                      )}
                      <div className="f12-500">
                        {this.props &&
                        this.props.typeOfQr &&
                        this.props.typeOfQr === "table"
                          ? "Table Number"
                          : "Seat Number"}{" "}
                        -{" "}
                        {this.props &&
                        this.props.typeOfQr &&
                        this.props.typeOfQr === "table" ? (
                          <>{data.table_number} </>
                        ) : (
                          <>{data.seat_number} </>
                        )}
                      </div>

                      <hr />
                      <div className="print-12-400-h">Scan via Amealio App</div>
                      <div className="">
                        <Image
                          fluid
                          src={require("../../../../../../../assets/images/UserManagement/fullLogo.svg")}
                          alt="Logo"
                          style={{ width: "25%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}
export default PrintComponent;
